module.exports = __webpack_public_path__ + "static/buffer-overflows-thumb-d9dc064ae559548057cc2a2df9ef8a53.png";